module.exports = __webpack_public_path__ + "static/track-5-bf19ebfbdb094a5b36b663f4ae24ddc3.jpg";